module.exports = __webpack_public_path__ + "static/media/viewie-logo-tekst-donker.dccf5104.svg";